"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: 2px solid #f4f4f4;\n  font-size: .75rem;\n  line-height: 18px;\n  font-weight: 400;\n  padding: 12px 0;\n  text-align: center;\n"], ["\n  border-top: 2px solid #f4f4f4;\n  font-size: .75rem;\n  line-height: 18px;\n  font-weight: 400;\n  padding: 12px 0;\n  text-align: center;\n"])));
exports.Wrapper.displayName = 'CopyrightSectionWrapper';
var templateObject_1;
